import { cn } from '@prenuvo/halo-foundation';

import { Loading } from '@/shared/ui';

interface DocumentLoadingProps {
  className?: string;
}

export function DocumentLoading({ className }: DocumentLoadingProps) {
  return <Loading className={cn('h-[calc(100vh-128px)]', className)} />;
}
